import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService, UserService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { EducationalInfoService } from '../educational-info/educational-info.service';
import { FileValidator } from '../../_validators/validators';
import Swal from 'sweetalert2'
import { UploadsService } from '../uploads/uploads.service';
import { CvService } from './cv.service';

@Component({
  selector: 'app-cv',
  templateUrl: './cv.component.html',
  styleUrls: ['./cv.component.css']
})
export class CvComponent implements OnInit {

  private loggedInUser: any;
  public educationTypes: any;
  public allowedExtensions = ['pdf'];
  public uploading: boolean;
  public pdfPicked: boolean;
  public maxFileSizeReached: boolean;

  constructor(private http: HttpClient,
    private uploadService: CvService,
    private userAccountService: UserService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private educationalInfoService: EducationalInfoService) {
    this.f.fileSource.valueChanges
      .subscribe(c => this.f.fileSource.updateValueAndValidity());
  }

  get f() {
    return this.uploadFileForm.controls;
  }

  public uploadSaved: boolean;

  uploadFileForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3)]),
    file: new FormControl('', [Validators.required]),
    fileSource: new FormControl('', [Validators.required])
  });

  ngOnInit(): void {
    this.maxFileSizeReached = false;
    this.pdfPicked = true;
    this.uploadSaved = false;
    this.uploading = false;
    // this.getEducationTypes();
  }

  onFileChange(event) {

    console.log('File size: ' + event.target.files[0].size);
    console.log('File type: ' + event.target.files[0].type);

    this.validateFileSize(event.target.files[0].size);

    if (!this.validateFileType(event.target.files[0].name)) {
      // console.log('Selected file format is not supported');
      return false;
    }

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadFileForm.patchValue({
        fileSource: file
      });
    }
  }

  // getEducationTypes() {
  //   this.educationalInfoService.getEducationalTypes().subscribe(response => {
  //     this.educationTypes = response;
  //   });
  // }

  uploadFile() {

    this.uploading = true;
    const formData = new FormData();
    formData.append('file', this.uploadFileForm.get('fileSource').value);
    formData.append('name', this.f.name.value);
    // formData.append('educationType', this.f.educationType.value);
    console.log("TAkuendesa ku servvice")
    if (this.authenticationService.currentUserValue) {
      return this.userAccountService.getCurrentUser()
        .subscribe(user => {
          console.log("Tadzokaku servvice")
          this.loggedInUser = user;
          return this.uploadService.uploadCV(formData)
            .subscribe(res => {

              if (res != null) {
                this.uploading = false;
                Swal.fire(
                  'Done!',
                  'Your Upload was successfully saved!',
                  'success'
                );
                console.log(res);
              } else {
                Swal.fire(
                  'Failed!',
                  'You exceeded maximum file size of 3MB!',
                  'error'
                );
              }
            });
        }
        );
    } else {
      this.router.navigate(['/login']).then(r => window.location.reload());
    }
  }

  validateFileType(name: string) {
    const ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() === 'pdf') {
      this.pdfPicked = true;
      return true;
    } else {
      this.pdfPicked = false;
      return false;
    }
  }

  validateFileSize(size: number) {
    if (Math.round(size / (1024 * 1024)) > 3) {
      this.maxFileSizeReached = true;
      return;
    } else {
      this.maxFileSizeReached = false;
    }
  }

}
